module.exports = __webpack_public_path__ + "fonts/NoirPro-Medium.3d82e791.woff2";